// This is a copy of the encodeAnchorName function from @wix/public-resolvers
// because we don't want to depend on it in this package
const encodeAnchorName = (anchorName: string): string => {
	return encodeURIComponent(anchorName).replace(/[!'()*]/g, (c) => {
		return c
	})
}

export const TOP_ANCHOR = 'SCROLL_TO_TOP'
export const BOTTOM_ANCHOR = 'SCROLL_TO_BOTTOM'
export const TOP_AND_BOTTOM_ANCHORS = [TOP_ANCHOR, BOTTOM_ANCHOR]
export const TOP_ANCHOR_NAME = encodeAnchorName('Top of Page')
export const BOTTOM_ANCHOR_NAME = encodeAnchorName('Bottom of Page')

export const topBottomAnchorNameToCompId = {
	[TOP_ANCHOR_NAME]: TOP_ANCHOR,
	[BOTTOM_ANCHOR_NAME]: BOTTOM_ANCHOR,
}
